import type { ReactNode } from "react";
import {
  AUDIENCE_VOICES,
  availableAudienceVoices,
  parseAudienceVoice,
  resolveAudienceCopy,
  type AudienceVoice,
} from "@/lib/audienceMode";

export function AudienceSection({
  content,
  children,
}: {
  content: Record<string, unknown>;
  children: (resolved: Record<string, unknown>, voice: AudienceVoice) => ReactNode;
}) {
  const voices = availableAudienceVoices(content);
  const fallback = parseAudienceVoice(content.defaultAudience);
  if (voices.length <= 1) {
    const voice = voices[0] ?? fallback;
    return <>{children(resolveAudienceCopy(content, voice), voice)}</>;
  }

  return (
    <div data-audience-block="">
      {AUDIENCE_VOICES.filter((voice) => voices.includes(voice)).map((voice) => (
        <div key={voice} data-audience={voice} hidden={voice !== fallback}>
          {children(resolveAudienceCopy(content, voice), voice)}
        </div>
      ))}
    </div>
  );
}
